import Login from "../../../Components/Admin/Login";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
